<ion-app (contextmenu)="blockRightClick($event)">
  <ion-router-outlet> </ion-router-outlet>
</ion-app>
